/* eslint-disable tailwindcss/no-custom-classname */
interface Props {
  text: string
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void
  isCancel?: boolean
  className?: string
}
export const RoundedButton: React.FC<Props> = ({
  text,
  onClick,
  isCancel = false,
  className = '',
}) => {
  return (
    <div className={`flex ${className}`}>
      <div
        className={`relative after:absolute after:top-[17px] after:right-[13px] items-center py-1 mx-auto mt-[15px] mb-[30px] w-[150px] after:w-[7px] after:h-[7px] rounded-full after:border-t-2 after:border-r-2 after:border-solid after:transform after:rotate-45 cursor-pointer after:content-[''] border border-solid border-[#1d6dcc] ${
          isCancel
            ? 'bg-white text-[#1d6dcc] after:border-[#1d6dcc]'
            : 'bg-fl-blue text-white after:border-[#fff]'
        }`}
        onClick={onClick}
      >
        <div className="text-center">
          <span className="my-0 mx-auto text-sm">{text}</span>
        </div>
      </div>
    </div>
  )
}
